import React from 'react'
import { Button } from 'hhsoig-design-system-core'
import { Divider } from '../../components/divider'
import ShareFeedback from './ShareFeedback'
import { withDocTitle } from '../../components/withDocTitle'
import css from './confirmation.module.css'

export const FugitiveConfirmation = ({ showFeedback }) => (
  <main data-testid="complaint-confirmation">
    <h1>Confirmation</h1>
    <p>
      Thank you for your submission. You have successfully submitted your tip.
    </p>
    <Button
      variation="secondary"
      data-testid="confirm-complaint"
      href="https://oig.hhs.gov/fraud/fugitives/"
      className={css.buttonSpacing}
    >
      Return to HHS-OIG Fugitives
    </Button>
    {showFeedback ? (
      <React.Fragment>
        <Divider />
        <ShareFeedback />
      </React.Fragment>
    ) : (
      ''
    )}
  </main>
)

export default withDocTitle(FugitiveConfirmation)
